export class ChatEvent {}

export class AllMessagesRead extends ChatEvent {
    constructor(public chatroomId: string) {
        super();
    }
}

export class ChatroomOpened extends ChatEvent {
    constructor(public chatroomId: string) {
        super();
    }
}
